import KnowledgeBaseUserManagement from "./KnowledgeBaseUserManagement";

export default KnowledgeBaseUserManagement;
